import { manifest } from './composition-picker/manifest.js';

export const manifests = [manifest];
